import { ButtonsGroup } from '@monorepo/shared/componentsV2/ButtonsGroup';
import { Header } from '@monorepo/shared/componentsV2/Header';
import { Search } from '@monorepo/shared/componentsV2/Search';
import { useHasOrganizationUpdatePermissions } from '@monorepo/shared/hooks/permissions/useHasPermissions';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { ButtonLink } from '../../../../shared/componentsV2/Link';
import { useOrgSpecificNewFormLink } from '../../hooks/useFormLinks';

const SearchContainer = styled.div`
  max-width: 10rem;
`;

const ButtonContainer = styled.div`
  min-width: 7rem;
`;

interface ViewFormsHeaderProps {
  filter: string;
  onSearch?: (search: string) => void;
  organizationId: string;
}

export function ViewFormsHeader({
  filter,
  onSearch,
  organizationId,
}: ViewFormsHeaderProps) {
  const newFormLink = useOrgSpecificNewFormLink();

  const hasOrgUpdatePermissions =
    useHasOrganizationUpdatePermissions(organizationId);

  const handleSearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onSearch?.(e.target.value),
    [onSearch],
  );

  return (
    <Header
      rightActions={
        <ButtonsGroup>
          {!!onSearch && (
            <SearchContainer>
              <Search onChange={handleSearch} value={filter} />
            </SearchContainer>
          )}
          {hasOrgUpdatePermissions && (
            <ButtonContainer>
              <ButtonLink to={newFormLink} color="primary" variant="contained">
                Create new form
              </ButtonLink>
            </ButtonContainer>
          )}
        </ButtonsGroup>
      }
      title="All Forms"
      variant="noDropShadow"
    />
  );
}
